import UibookCase from 'uibook/case'
import React from 'react'
import TelegramButton from '../TelegramButton'

const MODES = ['filled', 'bezeled', 'plain', 'gray', 'outline', 'white']

const I18N = {
  ru: {
    title: {
      filled: 'Filled кнопка',
      bezeled: 'Bezeled кнопка',
      plain: 'Plain кнопка',
      gray: 'Gray кнопка',
      outline: 'Outline кнопка',
      white: 'White кнопка',
    },
    hint: {
      filled: 'Основной CTA цвет Telegram.',
      bezeled: 'Мягкая вторичная кнопка.',
      plain: 'Прозрачная кнопка для тихих действий.',
      gray: 'Нейтральный акцент без яркой заливки.',
      outline: 'Контурная кнопка для фокуса и вторичных действий.',
      white: 'Светлая кнопка для темных поверхностей.',
    }
  },
  en: {
    title: {
      filled: 'Filled button',
      bezeled: 'Bezeled button',
      plain: 'Plain button',
      gray: 'Gray button',
      outline: 'Outline button',
      white: 'White button',
    },
    hint: {
      filled: 'Primary Telegram-like action style.',
      bezeled: 'Soft secondary action with subtle fill.',
      plain: 'Low-emphasis transparent action button.',
      gray: 'Neutral mode for utility actions.',
      outline: 'Border-first variant for secondary emphasis.',
      white: 'High-contrast light variant for dark surfaces.',
    }
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramButtonClick')
}

export default {
  background: 'light',
  component: TelegramButton,
  i18n: true,
  cases: MODES.map(mode => locale => <UibookCase props={{
    ...PROPS,
    mode: mode,
    description: I18N.en.hint[mode]
  }}>
    { I18N[locale].title[mode] }
  </UibookCase>)
}
